// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".txmap-container[data-v-bbe0fd1a] {\n  position: relative;\n  height: 100%;\n  width: 100%;\n}\n.txmap-container .option-area[data-v-bbe0fd1a] {\n  position: absolute;\n  left: 0.26667rem;\n  top: 0.26667rem;\n  background: #FFF;\n  padding: 0.26667rem;\n  z-index: 2;\n  white-space: nowrap;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
